export default __webpack_public_path__ + "static/27001-new-36ae1f3092e6ea112f45f3f157574541.jpg";